// @flow
import { addImageQueryParams, getCatalogUrl, getImageUrl } from '../../utils/urls';
import { getAd } from './catalogAd';
import { getCatalog } from './catalog';
import { getItem } from './item';
import { getSeller } from './seller';

export const getAdUnit = (state: any, categoryIds: any, keywords: any, pageName: any) => {
    const adUnit = getAd(state, categoryIds, keywords, pageName);

    if (adUnit.consignment) {
        const { adUnitId, imageUrl1, sellerId } = adUnit;
        const seller = getSeller(state, sellerId);

        return {
            adUnitId,
            consignment: true,
            imageUrl1,
            seller,
        };
    } else if (adUnit.adUnitId) {
        const { adUnitId, catalogId, destination, imageUrl1, imageUrl2, imageUrl3, itemId1, itemId2, itemId3 } = adUnit;

        const catalog = getCatalog(state, catalogId);
        const { saleStartTs, sellerId, title } = catalog;

        const seller = getSeller(state, sellerId);
        const { logoId, name } = seller;

        const item1 = getItem(state, itemId1);
        const primaryImageUrl =
            addImageQueryParams(imageUrl1, 162) ||
            getImageUrl({
                catalogId,
                imageNumber: 1,
                imageVersion: item1.imageVersion,
                itemId: itemId1,
                sellerId,
                width: 162,
            });

        const item2 = getItem(state, itemId2);
        const secondaryImageUrl =
            addImageQueryParams(imageUrl2, 162) ||
            getImageUrl({
                catalogId,
                imageNumber: 1,
                imageVersion: item2.imageVersion,
                itemId: itemId2,
                sellerId,
                width: 162,
            });

        const item3 = getItem(state, itemId3);
        const tertiaryImageUrl =
            addImageQueryParams(imageUrl3, 162) ||
            getImageUrl({
                catalogId,
                imageNumber: 1,
                imageVersion: item3.imageVersion,
                itemId: itemId3,
                sellerId,
                width: 162,
            });

        const adDestination = destination || (catalogId && getCatalogUrl(catalogId, title)) || '';

        return {
            adUnitId,
            catalogId,
            destination: adDestination,
            logoId,
            name,
            primaryImageUrl,
            saleStartTs,
            secondaryImageUrl,
            sellerId,
            tertiaryImageUrl,
            title,
        };
    }
};
